import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Collapse, Input, Button, Popconfirm, Icon } from 'antd'
import CKEditor from '@ckeditor/ckeditor5-react'
import CKEditorInline from '@ckeditor/ckeditor5-build-inline'

import { privileges } from '@services/api'

export default class Edit extends Component<any, any> {
    state = {
        status: '',
        disabled: true,
        active: 0,
        content: {
            name: '',
            content: ''
        },
        editedContent: {
            name: '',
            content: ''
        },
        id: ''
    }

    componentDidMount() {
        this.setContent()
    }

    setContent = () => {
        const { item } = this.props
        if (item) {
            this.setState({ editedContent: item, content: item, id: item.id, status: 'edit' })
        } else {
            this.setState({ status: 'add' })
        }
    }

    revertEditing = async () => {
        this.setState({ editedContent: this.state.content })
        this.setState({ disabled: true })
        this.toggleActive()
    }

    handleEditing = (field, value) => {
        this.setState(prevState => ({
            ...prevState,
            disabled: false,
            editedContent: { ...prevState.editedContent, [field]: value }
        }))
    }

    toggleActive = () => {
        const { status, active, id } = this.state
        if (status === 'add') {
            this.setState({ active: active ? 0 : 'add', disabled: true, editedContent: { name: '', content: '' } })
        } else if (status === 'edit') {
            this.setState({ active: active ? 0 : id, disabled: true })
        }
        this.setContent()
    }

    deletePrevilege = async () => {
        const { id } = this.state
        await privileges.deletePrivilege(id)
        this.toggleActive()
        this.props.privilegeUpdated()
    }

    submitPrivilege = async () => {
        const { id, editedContent, status } = this.state
        const { policy_id } = this.props

        if (status === 'edit') {
            await privileges.updatePrivilege({ ...editedContent, id, policy_id })
            this.toggleActive()
        } else if (status === 'add') {
            await privileges.addPrivilege({ ...editedContent, policy_id })
            this.toggleActive()
        }
        this.props.privilegeUpdated()
    }

    render() {
        const { editedContent, disabled, status, active } = this.state
        const { item, disable } = this.props

        let title

        if (item) {
            title = status === 'edit' && (
                <Fragment>
                    <div style={{ float: 'right' }}>
                        <strong style={{ color: '#464646' }}>{item['name']}</strong>
                    </div>
                    <div style={{ float: 'left' }}>
                        <span>{item['updated_by']}</span> -
                        <span>{moment(item['updated_at']).format('DD/MM/YY HH:mm')}</span>
                    </div>
                </Fragment>
            )
        } else {
            title = status === 'add' && (
                <div>
                    <Button type="primary">
                        <small style={{ fontSize: '0.8rem' }}>
                            <Icon type="plus" /> <strong style={{ fontSize: '1rem' }}>הוספת מאפיין</strong>
                        </small>
                    </Button>
                </div>
            )
        }

        const editButtons = !disable && (
            <Fragment>
                <Button onClick={() => this.revertEditing()} style={{ marginTop: '1rem' }}>
                    ביטול
                </Button>
                <Popconfirm
                    title="האם לשמור את השינויים?"
                    onConfirm={() => this.submitPrivilege()}
                    okText="כן"
                    cancelText="לא"
                    disabled={disabled}
                >
                    <Button type={'primary'} disabled={disabled} style={{ marginTop: '1rem' }}>
                        {status === 'edit' ? 'שמור שינויים' : 'הוסף מאפיין'}
                    </Button>
                </Popconfirm>
                {status === 'edit' ? (
                    <Popconfirm
                        title="האם למחוק מאפיין?"
                        onConfirm={() => this.deletePrevilege()}
                        okText="כן"
                        cancelText="לא"
                    >
                        <Button type="danger" style={{ marginTop: '1rem', float: 'left' }}>
                            מחק מאפיין
                        </Button>
                    </Popconfirm>
                ) : (
                    ''
                )}
            </Fragment>
        )

        return (
            <Collapse bordered={false} activeKey={active} onChange={() => this.toggleActive()}>
                <Collapse.Panel
                    className={status}
                    header={
                        <div
                            style={{ display: 'inline-block', width: '100%', lineHeight: '0.6rem' }}
                            onClick={() => this.toggleActive()}
                        >
                            {title}
                        </div>
                    }
                    key={status === 'edit' ? editedContent['id'] : 'add'}
                >
                    <Input
                        value={editedContent['name']}
                        placeholder="כותרת המאפיין"
                        disabled={disable}
                        onChange={e => this.handleEditing('name', e.target.value)}
                    />
                    <CKEditor
                        data={editedContent['content']}
                        editor={CKEditorInline}
                        disabled={disable}
                        onChange={(event, editor) => {
                            const data = editor.getData()
                            this.handleEditing('content', data)
                        }}
                        config={{
                            language: 'he',
                            toolbar: [
                                'heading',
                                '|',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'blockQuote',
                                'insertTable',
                                'undo',
                                'redo'
                            ]
                        }}
                    />
                    {editButtons}
                </Collapse.Panel>
            </Collapse>
        )
    }
}
